import React from 'react';

export const ChevronLeft = ({ color = '#F8F8FD' }: { color: string }) => (
  <svg width="100%" height="100%" viewBox="0 0 56 57" fill="none">
    <path d="M34 16.8345L22 28.8345L34 40.8345" stroke={color} strokeWidth="2" />
  </svg>
);
